export default __webpack_public_path__ + "static/media/Pinterest.cf9bd923.png";